export default __webpack_public_path__ + "static/media/Quickening Atlantean Catalyst.81fc9ebf.jpg";